import React from 'react';

const Sections = ({ children, gap = '1rem' }) => {
  return (
    <div className='w-full mr-11'>
      {children}
    </div>
  );
};

export default Sections;
